/* Avanti: Recently viewed products. Handles live in this browser's localStorage only. */
(function () {
  'use strict';

  var KEY = 'avanti:recently-viewed';
  var STORE_MAX = 8;
  var CARD_SECTION = 'avanti-rv-card';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      return list.filter(function (h) { return typeof h === 'string' && /^[a-z0-9][a-z0-9\-_.%]*$/i.test(h); });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, STORE_MAX))); } catch (e) {}
  }

  function remember(handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list);
  }

  function forget(handle) {
    write(read().filter(function (h) { return h !== handle; }));
  }

  function cardUrl(root, handle) {
    return root + '/products/' + encodeURIComponent(handle) + '?section_id=' + CARD_SECTION;
  }

  function fetchCard(root, handle) {
    return fetch(cardUrl(root, handle), { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (res) {
        if (res.status === 404) { forget(handle); return null; }
        if (!res.ok) return null;
        return res.text();
      })
      .then(function (html) {
        if (!html) return null;
        var holder = document.createElement('div');
        holder.innerHTML = html;
        return holder.querySelector('.product-block');
      })
      .catch(function () { return null; });
  }

  function afterInsert(section) {
    try {
      if (window.theme && theme.ProductBlockManager && typeof theme.ProductBlockManager.loadImages === 'function') {
        theme.ProductBlockManager.loadImages(section);
      }
    } catch (e) {}
    try {
      if (window.theme && typeof theme.initAnimateOnScroll === 'function') theme.initAnimateOnScroll();
    } catch (e) {}
  }

  function init(section) {
    if (!section || section.__avRv) return;
    section.__avRv = true;

    var current = section.getAttribute('data-handle') || '';
    var root = (section.getAttribute('data-root') || '').replace(/\/$/, '');
    var max = parseInt(section.getAttribute('data-max'), 10) || 8;
    var listEl = section.querySelector('[data-av-rv-list]');

    var handles = read().filter(function (h) { return h !== current; }).slice(0, max);
    remember(current);

    if (!listEl || !handles.length || !window.fetch) {
      section.hidden = true;
      return;
    }

    Promise.all(handles.map(function (h) { return fetchCard(root, h); })).then(function (cards) {
      var count = 0;
      cards.forEach(function (card) {
        if (!card) return;
        listEl.appendChild(card);
        count++;
      });
      section.hidden = count === 0;
      if (count) afterInsert(section);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-av-rv]'), init);
  }

  window.AvantiRecentlyViewed = { init: init, read: read, KEY: KEY };

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-av-rv]') : null;
    if (el) init(el);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
